import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="js-select2"
export default class extends Controller {
  static targets = ["fields", "alwaysVisibleOption"]

  connect() {
    this.initializeSelect2()
  }

  initializeSelect2() {
    const alwaysVisibleTexts = this.alwaysVisibleOptionTargets.map(el => el.textContent)

    $(this.fieldsTargets).each(function(){
      const config = {
        dropdownParent: $(this).parent(),
        dropdownAutoWidth: this.dataset.dropdownAutoWidth === 'true',
        width: "100%",
        theme: "bootstrap",
        allowClear: $(this).data('allowclear') !== undefined ? $(this).data('allowclear') : true,
        placeholder: $(this).data('placeholder'),
        minimumResultsForSearch: $(this).data('allowsearch') === false ? -1 : 0,
        matcher: function (params, data) {
          const emptySearch = $.trim(params.term) === ''
          const isAlwaysVisible = alwaysVisibleTexts.includes(data.text)
          const matchSearch = params.term && data.text.toLowerCase().includes(params.term.toLowerCase())

          if (emptySearch || isAlwaysVisible || matchSearch) return data;

          return null;
        },
        insertTag: function (data, tag) {
          data.push({ id: tag.id, text: `+ Créer ${tag.text}` });
        },
      }
      $(this).select2(config)
    })
  }
}
